<template>
  <FaIcon :icon="['fas', 'sitemap']" />
</template>
